import { cn } from "@/lib/utils";

/** Founder shell wordmark. Ignores the stored Atomic CRM title. */
export const ShellBrand = ({ className }: { className?: string }) => (
  <span
    className={cn(
      "inline-flex items-baseline gap-2 leading-none text-current",
      className,
    )}
  >
    <span className="text-[15px] font-semibold tracking-tight">毫厘</span>
    <span className="text-[13px] font-normal opacity-70">工作台</span>
  </span>
);
